import type { IconGlyph } from '@sunwebgroup/uds-ui/icon'
import type { CheckoutService, CheckoutServiceParticipant, CheckoutServiceRoom } from '@/scopes/checkout/domain/types'

export interface CheckoutCarRentalService extends CheckoutService {
  carLists?: {
    selectedValue: string
    selectedId: string
    driverId: string
    availableOptionsToUpgrade: CheckoutCarRentalServiceOption[]
  }[]
  availableDrivers: string[]
  participants: Record<string, CheckoutServiceParticipant>
  rooms?: Record<string, CheckoutServiceRoom>
  options: Record<string, CheckoutCarRentalServiceOption>
  usps: CheckoutCarRentalServiceUsp[]
  maxNumbersOfCarsToBeBooked: number
  isOpenJawPackage: boolean
  includedCarOutOfStock: boolean
  includedCarPriceChanged: boolean
  carProviderIsOutOfService?: boolean
  hasUnderageAdults: boolean
  configurations: {
    minAgeDriver: number
    rentalConditionsMinAgeDriver: number
    rentalConditionsMaxAgeDriver: number
  }
}

export interface CheckoutCarRentalServiceOption {
  label: string
  value: string
  id: string
  price: number
  features: CheckoutCarRentalServiceOptionFeature[]
  extraFeatures?: CheckoutCarRentalServiceOptionExtraFeature[]
  equipments: CheckoutCarRentalEquipment[]
  selectedEquipments: string[]
  selectedEquipmentsWithQuantity?: CheckoutCarRentalEquipmentSelected[]
  location: {
    text: string
    icon: IconGlyph | null
  }
  driverId: string | null
  image: string
  carClass: string
  conditionsUrl: string
  canBeRemoved: boolean
  canBeEdited: boolean
  canBeUpgraded: boolean
  availableOnRequest: boolean
  maxNumberOfEquipments: number
  openJawFeeAmount: number
  isIncluded: boolean
  additionalCosts?: Record<string, CheckoutCarAdditionalCost>
}

export const AdditionalCostTypeValues = {
  OUT_OF_HOUR: 'outOfHour',
  ONE_WAY: 'oneWay',
  ENVIRONMENTAL_FEE: 'environmentalFee',
  UNKNOWN: 'unknown',
} as const

export type AdditionalCostType = (typeof AdditionalCostTypeValues)[keyof typeof AdditionalCostTypeValues]

export interface CheckoutCarAdditionalCost {
  aproxFeeAmount: number
  description: string
}

export interface CheckoutCarRentalEquipment {
  id: string
  text: string
  price?: number
  maxQuantity?: number
  quantitySelected?: number
}

export interface CheckoutCarRentalEquipmentSelected {
  id: string
  quantity: number
}

export interface CheckoutCarRentalServiceUsp {
  link?: string
  text: string
}

export interface CheckoutCarRentalServiceOptionFeature {
  text?: string
  glyph?: IconGlyph
}

export interface CheckoutCarRentalServiceOptionExtraFeature {
  glyph?: IconGlyph
  values?: string[]
}
